import React from 'react'
import { Pressable, View, useWindowDimensions } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { AppModal } from '../ui/AppModal'
import { DiceLuckHelp } from '../game/DiceLuckHelp'

/** The in-game "How Dice Luck Works" explainer, without the live per-game maths. */
export function DiceLuckHelpModal({ visible, onClose }: { visible: boolean; onClose: () => void }) {
  const insets = useSafeAreaInsets()
  const { height } = useWindowDimensions()
  const maxHeight = Math.max(320, height - insets.top - insets.bottom - 32)
  return (
    <AppModal visible={visible} transparent animationType="fade" onRequestClose={onClose}>
      <View
        className="flex-1 bg-black/60 items-center justify-center"
        style={{ paddingTop: insets.top + 16, paddingBottom: insets.bottom + 16, paddingHorizontal: 16 }}
      >
        <Pressable
          accessible={false}
          onPress={onClose}
          style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0 }}
        />
        <View
          testID="hof-dice-luck-help"
          className="w-full bg-paper border-2 border-olive rounded-2xl overflow-hidden"
          style={{ maxWidth: 620, maxHeight }}
        >
          <DiceLuckHelp onBack={onClose} backLabel="Close dice luck help" backGlyph="×" />
        </View>
      </View>
    </AppModal>
  )
}
